import styled from '@emotion/styled';
import { ClaimIdBadge } from '../../badge';
import { Variables } from '../../base';

interface INote {
    note?: boolean;
}

const PanelElement = styled.div`
    padding: 8px 24px;
`;

const noteHeader = `
    padding: 8px 0;
    margin: 8px;
    border: 1px solid ${Variables.Colors.b100};
    border-radius: 8px;
    background-color: ${Variables.Colors.b300_l96};
`;

const commentHeader = `
    padding: 8px 8px;
    color: ${Variables.Colors.n85};
    background-color: ${Variables.Colors.white};
`;

export const Header = styled.div<INote>`
    ${(props: INote): string | undefined => (props.note ? noteHeader : commentHeader)}
`;

export const Row = styled(PanelElement)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Timestamp = styled.div`
    font-size: 14px;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n70};
`;

export const NoteLabel = styled.div`
    background-color: ${Variables.Colors.b100};
    color: ${Variables.Colors.white};
    font-size: smaller;
    text-transform: uppercase;
    padding: 0 4px;
`;

export const Subject = styled(PanelElement)`
    font-size: 20px;
    line-height: 1.25;
    color: ${Variables.Colors.n100};
`;

export const EditableSubject = styled(PanelElement)`
    cursor: pointer;
`;

export const ClaimWrapper = styled.div`
    padding: 12px 24px;
`;

export const ClaimButton = styled(ClaimIdBadge)`
    margin-right: 8px;
    margin-bottom: 8px;
    align-self: baseline;
`;

export const FieldRow = styled(PanelElement)`
    display: flex;
    gap: 16px;
    align-items: flex-start;
`;

export const FieldColumn = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

export const FieldLabel = styled.div`
    margin: 0 0 6px 0;
    padding: 0;
    font-size: 16px;
    font-weight: normal;
    color: ${Variables.Colors.n70};
`;

export const Body = styled(PanelElement)`
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n85};

    pre, code {
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;

export const Attachments = styled(PanelElement)``;

export const UpdateButtonRow = styled(PanelElement)`
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
`;

export const TagsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const TagsLabel = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

// Codings table styles
export const CodingsTableWrapper = styled.div`
    padding: 0 24px;
    margin-top: 8px;
    
    & > div {
        border: 1px solid ${Variables.Colors.platinum};
        border-radius: 4px;
        overflow: hidden;
    }
`;

export const CodingsTableContainer = styled.div`
    border-top: 1px solid ${Variables.Colors.platinum};
`;

export const CodingsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const CodingsTableHead = styled.thead`
    background-color: ${Variables.Colors.n5};
    border-bottom: 2px solid ${Variables.Colors.platinum};
`;

export const CodingsTableBody = styled.tbody``;

export const CodingsTableRow = styled.tr`
    &:not(:last-child) {
        border-bottom: 1px solid ${Variables.Colors.platinum};
    }
    
    &:hover {
        background-color: ${Variables.Colors.n5};
    }
`;

export const CodingsTableHeaderCell = styled.th`
    text-align: left;
    padding: 12px;
    font-size: 12px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const CodingsTableCell = styled.td`
    padding: 12px;
    font-size: 14px;
    color: ${Variables.Colors.n85};
    vertical-align: middle;
    border-bottom: inherit;
`;

export const NotesCell = styled(CodingsTableCell)`
    max-width: 500px;
    white-space: normal;
    word-break: break-word;
`;

export const InfoButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background-color: transparent;
    border: 1px solid ${Variables.Colors.b200};
    border-radius: 4px;
    color: ${Variables.Colors.b300};
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 12px;

    &:hover {
        background-color: ${Variables.Colors.b50};
        border-color: ${Variables.Colors.b300};
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const EmptyMessage = styled.div`
    padding: 16px 8px;
    text-align: center;
    color: ${Variables.Colors.n50};
    font-size: 14px;
    font-style: italic;
`;
